export default "__VITE_PUBLIC_ASSET__cbf4dfb3__"